import { NgModule } from '@angular/core';

import { ButtonSliderArrowComponent } from './button-slider-arrow.component';

@NgModule({
  declarations: [ButtonSliderArrowComponent],
  exports: [ButtonSliderArrowComponent]
})
export class ButtonSliderArrowModule {}

export * from './button-slider-arrow.component';
